<lib-multilingual-editor-marketing
[endpoint]="editorConfig.endpoint"
[lang]="editorConfig.lang"
[minHeight]="editorConfig.minHeight"
[sessionLimit]="editorConfig.sessionLimit"
(showSnackBarEvent)="showSnackBar($event)"
(sessionExhaustedEvent)="sessionExhausted($event)"
(openFeedbackModalEvent)="openFeedbackModal($event)"
></lib-multilingual-editor-marketing>